import { render, staticRenderFns } from "./TemplateCollectionPublic.vue?vue&type=template&id=64c03802&scoped=true&"
import script from "./TemplateCollectionPublic.vue?vue&type=script&lang=ts&"
export * from "./TemplateCollectionPublic.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateCollectionPublic.vue?vue&type=style&index=0&id=64c03802&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c03802",
  null
  
)

export default component.exports